import { Col, Row } from 'antd';
import Text from 'components/Text';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import { IPrintSalaryStaffDetailRangeDate_Detail } from 'features/report/services/types/reportStaff';
import moment from 'moment';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

type Props = {
  data?: IPrintSalaryStaffDetailRangeDate_Detail[];
};
const StaffDateTable = ({ data }: Props) => {
  return (
    <>
      <Header>
        <ColHeader span={10}>DATE</ColHeader>
        <ColHeader span={7} style={{ textAlign: 'end' }}>PRICE</ColHeader>
        <ColHeader span={7} style={{ textAlign: 'end' }}>TIPS</ColHeader>
      </Header>
      {data?.map(item => (
        <Row key={item.createdDate} style={{ padding: '1px 0px' }}>
          <ColHeader span={10}>
            <Text variant='CAPTION_3' printMode>{item?.billDate || moment(item?.createdDate).format(DATE_FORMAT)}</Text>
          </ColHeader>
          <ColHeader span={7} style={{ textAlign: 'end' }}><Text variant='CAPTION_3' printMode >{formatCurrency(item?.price)}</Text></ColHeader>
          <ColHeader span={7} style={{ textAlign: 'end' }}><Text variant='CAPTION_3' printMode >{formatCurrency(item?.tip)}</Text></ColHeader>
        </Row>
      ))}
    </>
  );
};

export default StaffDateTable;

const Header = styled(Row)`
  border-top:1px solid black;
  border-bottom: 1px dashed black;
`;

const ColHeader = styled(Col)`
    color:  black;
    padding: 1px 0px;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;
